export default "__VITE_ASSET__z_u4tEsc__"